export const LOCAL_STORAGE_AUTH_CHECK_KEY = `@mst/login`;

// kenny: 로컬에서는 매번 로그인 시마다 Application > Cookies에서 받아와서 넣어줘야 함
//        정확한 이유는 모르는데, 쿠키 설정 중 HttpOnly, Same-Origin, Secure 옵션과 관련이 있는 듯
export const LOCAL_CSRF_TOKEN = "l2VHAa3HJ94zICQtisKUGRea3bDgWQFMgIcsdBh74rHV8AKsbZa5oX3wuLQDhbYJ";

export const CSRF_STORAGE_KEY = "mst:csrftoken";

/**
 * 권한 없는 매장에 접근했을 때 백엔드가 403 응답 body 의 `code` 로 내려주는 값.
 * 레거시 백엔드가 미인증에도 403 을 쓰기 때문에 상태 코드만으로는 구분할 수 없고,
 * 구분하지 못하면 권한 없는 매장 링크를 여는 것만으로 로그아웃되어 버린다.
 * (백엔드: common/permissions.py HasBranchAccess)
 */
export const BRANCH_FORBIDDEN_CODE = "branch_forbidden";
